/* eslint-disable */
import { Loading, Message } from 'element-ui';
import axios from './http'
function $get(url, params) {
  const loading = Loading.service({ fullscreen: true });
  return axios({
    method: 'get',
    url: url,
    params: params
  }).then(res => {
    loading.close();
    if (res.code == 0) {
      return res.data
    } else {
      Message.error(res.msg);
    }
  }).catch(function (error) {
    loading.close();
    return Promise.reject(error)
  });
}

function $post(url, data, isLoading = 1) {
  let loading = null
  if (isLoading) {
    loading = Loading.service({ fullscreen: true });
  }
  return axios.post(url, data).then(res => {
    isLoading && loading.close();
    if (res && res.code == 0) {
      return res.data
    } else {
      Message.error(res.msg);
    }
  }).catch(function (error) {
    isLoading && loading.close();
    return Promise.reject(error)
  });

}




export const question = (data) => {
  return $post("/api.question/index", data, false)
}

export const login = (data) => {
  return $post('/api.login/login', data)
}

export const register = (data) => {
  return $post('/api.login/register', data)
}

export const updatepassword = (data) => {
  return $post('/api.login/updatepassword', data)
}

export const sendcode = (data) => {
  return $post('/api.login/sendcode', data)
}

export const search = (data) => {
  return $post('/api.gene/index', data)
}

export const getInfo = (data) => {
  return $post('/api.illness/info', data)
}

export const getGene = (data) => {
  return $post('/api.gene/gene', data)
}
